import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';

const fetchBrowseNodes = async () => {
  try {
    return await API.get(APIEndpoints.BROWSE_NODES);
  } catch (error) {
    console.error(error);
  }
};
const fetchImpactMetrics = async () => {
  try {
    return await API.get(`${window.location.origin}${APIEndpoints.IMPACT_METRICS}`);
  } catch (error) {
    console.error(error);
  }
};
const fetchBrowseNodeMaterials = async () => {
  try {
    return await API.get(APIEndpoints.BROWSE_NODES_MATERIAL);
  } catch (error) {
    console.error(error);
  }
};

export const BrowseNodeAPI = {
  fetchBrowseNodes,
  fetchImpactMetrics,
  fetchBrowseNodeMaterials,
};
